module.exports = __webpack_public_path__ + "static/media/nod-logo.e4cd22fc.jpg";